import { useEffect, useRef } from 'react';

import Icon from '#@/components/Icon';
import MessagePopup from '#@/components/MessagePopup';
import { COLOR } from '#@/shared/utils/styles';

import type { ToastObject } from './types';

const toastTypeToIconTypeMap = {
  danger: 'alert-fat',
  warning: 'alert-fat',
  success: 'check-fat',
  info: 'info',
} as const;

const toastTypeToColorMap = {
  danger: COLOR.danger,
  warning: COLOR.warning,
  success: COLOR.success,
  info: COLOR.brand,
} as const;

export function SingleToast({
  onRemove,
  id,
  type,
  duration = 5,
  title,
  message,
}: ToastObject & { onRemove(): void }) {
  const onRemoveRef = useRef(onRemove);
  onRemoveRef.current = onRemove;

  useEffect(() => {
    if (!duration) {
      return;
    }

    const timeout = setTimeout(() => {
      onRemoveRef.current?.();
    }, duration * 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [duration, id]);

  return (
    <MessagePopup
      data-testid="toast"
      data-cy-toast
      data-cy-toast-type={type}
      color={toastTypeToColorMap[type]}
      title={title}
      message={message}
      onClick={() => onRemove()}
      leftIcon={<Icon type={toastTypeToIconTypeMap[type]} size={16} color={COLOR.white} />}
      rightIcon={<Icon type="close" size={16} color={COLOR.white} />}
    />
  );
}
